import { ReporterI } from "./Reporter";

export default class PerformanceAPIReporter implements ReporterI {

    name: string;
    startTime: number | null = null

    /**
     * @constructor
     * @param {string} name
     */
    constructor(name: string) {
        this.name = name;
    }

    /**
     * Creates a mark for beginning of measure
     */
    start() {
        this.startTime = performance.now();
        this.mark("start");
    }

    /**
     * Creates a mark for end of measure
     */
    end() {
        if (!this.startTime) {
            return;
        }

        this.mark("end");

        performance.measure(this.name, `${ this.name }.start`, `${ this.name }.end`);
    }

    /**
     * Marks a single event in time
     */
    mark(action: string) {
        return performance.mark(`${ this.name }.${ action }`);
    }

}
